module.exports = __webpack_public_path__ + "static/media/end_object.63d77559.png";